import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  table: {
    tableLayout: 'auto',
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF',
      padding: '12px 8px',
      whiteSpace: 'nowrap',
      tableLayout: 'inherit',
      maxWidth: '170px',
      overflow: 'hidden'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px',
      padding: '12px 8px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fill: '#4B6FC2',
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    }
  },
  tableRequestAccess: {
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF',
      padding: '12px 0px',
      textAlign: 'center'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px',
      padding: '12px 24px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fill: '#4B6FC2',
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    }
  },
  checkBoxCell: {
    '& .MuiTableCell-root': {
      width: '100px'
    }
  }
}));
